import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import React from 'react';
import { Icon } from '../index';
import classNames from 'classnames';
import { tuple } from '../_utils/type';
var ClearableInputType = tuple('input', 'text');
export function hasPrefixSuffix(props) {
  return !!(props.prefix || props.suffix || props.allowClear);
}

var ClearableInput = function ClearableInput(props) {
  var prefixCls = props.prefixCls,
      prefix = props.prefix,
      suffix = props.suffix,
      allowClear = props.allowClear,
      value = props.value,
      disabled = props.disabled,
      inputType = props.inputType,
      handleReset = props.handleReset,
      element = props.element,
      className = props.className,
      size = props.size,
      borderType = props.borderType,
      style = props.style,
      addonBefore = props.addonBefore,
      addonAfter = props.addonAfter,
      focused = props.focused,
      numberMark = props.numberMark;

  var renderClearIcon = function renderClearIcon() {
    var _classNames;

    if (!allowClear) {
      return null;
    }

    var needClear = !disabled && value;
    var clearIconclasses = classNames((_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-textarea-clear-icon"), inputType === ClearableInputType[1]), _defineProperty(_classNames, "".concat(prefixCls, "-clear-icon"), inputType === ClearableInputType[0]), _defineProperty(_classNames, "".concat(prefixCls, "-clear-icon-hidden"), !needClear), _defineProperty(_classNames, "".concat(prefixCls, "-clear-icon-rightSpace"), suffix), _classNames));
    return /*#__PURE__*/React.createElement("span", {
      onClick: handleReset,
      className: clearIconclasses
    }, typeof allowClear === 'boolean' ? /*#__PURE__*/React.createElement(Icon, {
      type: "close"
    }) : allowClear);
  };

  var renderSuffix = function renderSuffix() {
    if (suffix || !disabled && !!allowClear) {
      return /*#__PURE__*/React.createElement("span", {
        className: "".concat(prefixCls, "-suffix")
      }, renderClearIcon(), suffix);
    }

    return null;
  };

  var renderInputWithFixNode = function renderInputWithFixNode(originElement) {
    var _context, _classNames2;

    if (!hasPrefixSuffix(props)) {
      return originElement;
    }

    var suffixNode = renderSuffix();
    var prefixNode = prefix ? /*#__PURE__*/React.createElement("span", {
      className: "".concat(prefixCls, "-prefix")
    }, prefix) : null;
    var inputWrapperClasses = classNames((_classNames2 = {}, _defineProperty(_classNames2, "".concat(prefixCls, "-wrapper"), true), _defineProperty(_classNames2, "".concat(prefixCls, "-wrapper-focused"), focused && !disabled), _defineProperty(_classNames2, "".concat(prefixCls, "-wrapper-disabled"), disabled), _defineProperty(_classNames2, _concatInstanceProperty(_context = "".concat(prefixCls, "-wrapper-size-")).call(_context, size), size), _defineProperty(_classNames2, "".concat(prefixCls, "-wrapper-borderless"), borderType === 'none'), _defineProperty(_classNames2, "".concat(prefixCls, "-wrapper-underline"), borderType === 'underline'), _classNames2), _defineProperty({}, className, className && !addonBefore && !addonAfter));
    return /*#__PURE__*/React.createElement("span", {
      className: inputWrapperClasses,
      style: style
    }, prefixNode, /*#__PURE__*/React.cloneElement(originElement, {
      style: null
    }), suffixNode);
  };

  var renderInputWithLabel = function renderInputWithLabel(originElement) {
    var _classNames4, _context2, _classNames5;

    if (!addonBefore && !addonAfter) {
      return originElement;
    }

    var addonClassName = classNames("".concat(prefixCls, "-group-addon"), (_classNames4 = {}, _defineProperty(_classNames4, "".concat(prefixCls, "-group-addon-borderless"), borderType === 'none'), _defineProperty(_classNames4, "".concat(prefixCls, "-group-addon-underline"), borderType === 'underline'), _defineProperty(_classNames4, "".concat(prefixCls, "-group-addon-disabled"), disabled), _classNames4));
    var addonBeforeNode = addonBefore ? /*#__PURE__*/React.createElement("span", {
      className: addonClassName
    }, addonBefore) : null;
    var addonAfterNode = addonAfter ? /*#__PURE__*/React.createElement("span", {
      className: addonClassName
    }, addonAfter) : null;
    var inputGroupClasses = classNames(className, (_classNames5 = {}, _defineProperty(_classNames5, "".concat(prefixCls, "-group"), true), _defineProperty(_classNames5, _concatInstanceProperty(_context2 = "".concat(prefixCls, "-group-size-")).call(_context2, size), size), _classNames5));
    return /*#__PURE__*/React.createElement("span", {
      className: "".concat(prefixCls, "-group-wrapper")
    }, /*#__PURE__*/React.createElement("span", {
      className: inputGroupClasses,
      style: style
    }, addonBeforeNode, /*#__PURE__*/React.cloneElement(originElement, {
      style: null
    }), addonAfterNode));
  };

  var renderTextAreaWithLabel = function renderTextAreaWithLabel(originElement) {
    if (!allowClear) {
      return originElement;
    }

    var _ref = style || {},
        width = _ref.width,
        margin = _ref.margin,
        marginLeft = _ref.marginLeft,
        marginRight = _ref.marginRight,
        marginTop = _ref.marginTop,
        marginBottom = _ref.marginBottom;

    var wrapperStyle = style ? {
      width: width,
      margin: margin,
      marginLeft: marginLeft,
      marginRight: marginRight,
      marginTop: marginTop,
      marginBottom: marginBottom
    } : {};

    for (var key in wrapperStyle) {
      if (wrapperStyle[key] === undefined) {
        delete wrapperStyle[key];
      }
    }

    var textAreaWrapperClasses = classNames(className, _defineProperty({}, "".concat(prefixCls, "-wrapper-textarea"), true));
    return /*#__PURE__*/React.createElement("span", {
      className: textAreaWrapperClasses,
      style: wrapperStyle
    }, originElement, renderClearIcon(), numberMark && numberMark);
  };

  if (inputType === ClearableInputType[0]) {
    return renderInputWithLabel(renderInputWithFixNode(element));
  }

  return renderTextAreaWithLabel(element);
};

export default ClearableInput;